import React from "react";
import PropTypes from "prop-types";
import { Icon } from "discover.medical.react-component-library";
import { StyledSuccessButton } from "./styled";

const SuccessCenterButton = ({ onClick, isMobile }) => {
  return (
    <StyledSuccessButton
      variant="secondary"
      size={"sm"}
      data-testid="success-center-button"
      id="success_center_button"
      onClick={onClick}
      aria-label={isMobile ? "Support Center" : ""}
    >
      <Icon icon={{ glyph: "success", size: "sm" }} />
      {isMobile ? <></> : <span>Support Center</span>}
    </StyledSuccessButton>
  );
};

SuccessCenterButton.displayName = "SuccessCenterButton";

SuccessCenterButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isMobile: PropTypes.bool
};

export default SuccessCenterButton;
